import { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';

import { PaidConfirmModal } from '../../PaidConfirmModal/PaidConfirmModal';

type SuccessModalProps = {
  onSuccess: () => void;
};

export const SuccessModal = ({ onSuccess }: SuccessModalProps) => {
  const [isActive, setIsActive] = useState(false);
  const [searchParams, setSearchParams] = useSearchParams();
  const isSuccess = searchParams.get('status') === 'success';

  useEffect(() => {
    if (isSuccess) {
      setIsActive(true);
    }
  }, [isSuccess]);

  const clearStatus = () => {
    searchParams.delete('status');
    setSearchParams(searchParams);
  };

  const handleClose = () => {
    setIsActive(false);
    clearStatus();
  };

  const handleSuccess = () => {
    setIsActive(false);
    clearStatus();
    onSuccess();
  };

  return <PaidConfirmModal open={isActive} onSuccess={handleSuccess} onClose={handleClose} />;
};
